import { Grid, GridItem } from "@chakra-ui/react";
import React from "react";
import "./css/skills.css";
const Skills = () => {
  return (
    <div className="skills" id="skills">
      <div className="skillheading">
        {" "}
        <h1 className="subskillheading">Skills</h1>
      </div>
      <div className="skillmain">
        <div className="subskills animate delay-1">
          <img className="skillimage3" src="/html.png" alt=""></img>
          <p className="skillname">HTML</p>
        </div>
        <div className="subskills animate delay-1">
          <img className="skillimage2" src="/cssw.png" alt=""></img>
          <p className="skillname">CSS</p>
        </div>
        <div className="subskills animate delay-1">
          <img className="skillimage1" src="/js.png" alt=""></img>
          <p className="skillname">JavaScript</p>
        </div>
        <div className="subskills animate delay-1">
          <img className="skillimage4" src="/reactw.jpg" alt=""></img>
          <p className="skillname">React</p>
        </div>
        <div className="subskills animate delay-2">
          <img className="skillimage5" src="/redux.png" alt=""></img>
          <p className="skillname">Redux</p>
        </div>

        <div className="subskills animate delay-2">
          <img className="skillimage7" src="/node.png" alt=""></img>
          <p className="skillname"> Node JS</p>
        </div>
        <div className="subskills animate delay-2">
          <img className="skillimage8" src="/express.png" alt=""></img>
          <p className="skillname">Express JS</p>
        </div>
        <div className="subskills animate delay-2">
          <img className="skillimage11" src="/chakra.png" alt=""></img>
          <p className="skillname">Chakra UI</p>
        </div>
        <div className="subskills animate delay-3">
          <img className="skillimage13" src="python.png" alt=""></img>
          <p className="skillname">python</p>
        </div>
        <div className="subskills animate delay-3">
          <img className="skillimage12" src="/flask.png" alt=""></img>
          <p className="skillname">Flask</p>
        </div>
        <div className="subskills animate delay-3">
          <img className="skillimage9" src="/mongoose.png" alt=""></img>
          <p className="skillname">Mongoose</p>
        </div>
        <div className="subskills animate delay-3">
          <img className="skillimage6" src="/mongodb.png" alt=""></img>
          <p className="skillname"> Mongo DB</p>
        </div>

        <div className="subskills animate delay-4">
          <img className="skillimage14" src="/mysql.png" alt=""></img>
          <p className="skillname">Mysql</p>
        </div>
        <div className="subskills animate delay-4">
          <img className="skillimage10" src="/firebase.png" alt=""></img>
          <p className="skillname">FireBase</p>
        </div>
      </div>
    </div>
  );
};
export default Skills;
